
import CheckIcon from "vue-material-design-icons/CheckBold";

export default {
  name: "CheckBox",
  components: {
    CheckIcon
  },
  props: {
    label: {
      type: String
    },
    value: {
      required: true
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    border: {
      type: String,
      default: () => "default",
      validator: value => ["default", "white"].indexOf(value) > -1
    }
  },
  methods: {
    updateValue() {
      this.$emit("input", !this.value);
    }
  },
  computed: {
    checkboxClass() {
      return {
        "border-white": this.border === "white"
      };
    }
  }
};
